/*
 * @Author: huangshimin@klcxkj.com
 * @Date: 2022-03-28 16:41:39
 * @LastEditors: huangshimin@klcxkj.com
 * @LastEditTime: 2022-04-15 20:37:43
 * @FilePath: \client-h5\src\pages\waterUseRecord\services.js
 */
import http from '../../utils/http';
/**
 * 获取用水信息
 */
 export function getWateruse() {
  return http("get", '/room/usewater/logs');
}


